module.exports = __webpack_public_path__ + "static/img/36.54df4a36.png";